<template>
  <Row type="flex" justify="center" align="middle" class="login" @keydown.enter.native="submitLogin">
    <Col :xs="{span:22}" style="width: 368px;" clss="login-container">
    <Row class="header" style="width: 580px; transform: translateX(-27%);">
      <img src="../../assets/logo.png" width="100px" />
      <!-- <div class="description">电梯物联网系统</div> -->
      <!-- <div class="description">智慧电梯全生命周期管理系统</div> -->
      <div class="description">电梯AI全生命周期管理系统</div>
      <br>
    </Row>
    <br>
    <Alert type="error" show-icon v-if="error">{{errorMsg}}</Alert>
    <Row class="login-form">
      <Form ref="usernameLoginForm" :model="form" :rules="rules" class="form">
        <FormItem prop="userName">
          <Input v-model="form.userName" prefix="ios-contact" size="large" clearable placeholder="请输入用户名"
            autocomplete="off" />
        </FormItem>
        <FormItem prop="passWord">
          <Input type="password" v-model="form.passWord" prefix="ios-lock" size="large" clearable placeholder="请输入密码"
            autocomplete="off" />
        </FormItem>
      </Form>

      <!-- <Row type="flex" justify="space-between" class="code-row-bg">
        <Checkbox v-model="saveLogin" size="large">自动登录</Checkbox>
        <Dropdown trigger="click" @on-click="handleDropDown">
          <a class="forget-pass">忘记密码</a>
          <DropdownMenu slot="list">
            <DropdownItem name="showAccount">体验测试账号</DropdownItem>
            <DropdownItem name="resetByMobile">使用手机号重置密码(开发中)</DropdownItem>
            <DropdownItem name="resetByEmail">使用邮箱重置密码(开发中)</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </Row> -->
      <Row>
        <Button class="login-btn" type="primary" size="large" :loading="loading" @click="submitLogin" long>
          <span v-if="!loading">登录</span>
          <span v-else>登录中...</span>
        </Button>
      </Row>
    </Row>

    <Row class="foot">
      <Row type="flex" justify="space-around" class="code-row-bg help">
        <a class="item" href="#" target="_blank">帮助</a>
        <a class="item" href="#" target="_blank">隐私</a>
        <a class="item" href="#" target="_blank">条款</a>
      </Row>
      <Row type="flex" justify="center" class="code-row-bg copyright">
        Copyright © {{new Date().getFullYear()}} - 上海麦信数据科技有限公司
      </Row>
    </Row>
    </Col>
  </Row>
</template>

<script>
export default {
  data() {
    const validateMobile = (rule, value, callback) => {
      var reg = /^[1][3,4,5,7,8][0-9]{9}$/
      if (!reg.test(value)) {
        callback(new Error('手机号格式错误'))
      } else {
        callback()
      }
    }
    return {
      error: false,
      errorMsg: '',
      tabName: 'username',
      saveLogin: true,
      loading: false,
      sending: false,
      sended: false,
      count: 60,
      countButton: '60 s',
      maxLength: 6,
      errorCode: '',
      form: {
        userName: '',
        passWord: '',
        mobile: '',
        code: ''
      },
      rules: {
        userName: [
          {
            required: true,
            message: '账号不能为空',
            trigger: 'blur'
          }
        ],
        passWord: [
          {
            required: true,
            message: '密码不能为空',
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            message: '手机号不能为空',
            trigger: 'blur'
          },
          {
            validator: validateMobile,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    showErrorMsg(msg) {
      this.error = true
      this.errorMsg = msg
    },
    sendVerify() {
      this.$refs.mobileLoginForm.validate(valid => {
        if (valid) {
          this.showErrorMsg('开发中····')
        }
      })
    },
    countDown() {
      const that = this
      if (this.count === 0) {
        this.sended = false
        this.count = 60
        return
      } else {
        this.countButton = this.count + ' s'
        this.count--
      }
      setTimeout(function() {
        that.countDown()
      }, 1000)
    },
    submitLogin() {
      this.$refs['usernameLoginForm'].validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('menu/loginStore', this.form).then(res => {
            this.$router.push({ path: '/index' })
            this.loading = false
          }).catch(response => {
            this.$Message.error(response.data.message || '登录失败，请重试')
            this.loading = false
          })
        }
      })
    },
    toGithubLogin() {
      this.showErrorMsg('开发中····')
    },
    toQQLogin() {
      this.showErrorMsg('开发中····')
    },
    toWeiboLogin() {
      this.showErrorMsg('开发中····')
    },
    toWeixinLogin() {
      this.$Message.error('开通微信登录官方收费300/年')
    },
    relatedLogin() {},
    handleDropDown(v) {
      if (v === 'showAccount') {
        this.showAccount()
      } else if (v === 'resetByMobile') {
        this.showErrorMsg('开发中····')
      } else if (v === 'resetByEmail') {
        this.showErrorMsg('开发中····')
      }
    }
    // showAccount() {
    //   this.$Notice.info({
    //     title: "体验账号密码",
    //     desc:
    //       "账号1：test 密码：123456 <br>账号2：test2 密码：123456 已开放注册！",
    //     duration: 10
    //   });
    // },
    // showMessage() {
    //   this.$Notice.success({
    //     title: "",
    //     desc: "完善多项功能，包括数据权限、部门管理、定时任务、数据字典、前端模版等 修复已知BUG",
    //     duration: 5
    //   });
    // }
  },
  mounted() {
    this.relatedLogin()
  }
}
</script>

<style lang="scss">
@import "./login.scss";
</style>
<style></style>
